export const version = "bytes/5.7.0";
//# sourceMappingURL=_version.js.map